
import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, DialogContentText
, IconButton, CircularProgress
} from "@mui/material";import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import Header from "../Header/Header";
import IdealCandidatesListingContainer from "../IdealCandidatesListing/IdealCandidatesListingContainer";
import IdealCandidateViewContainer from "../IdealCandidateView/IdealCandidateViewContainer";
import PersonalAccessTokensContainer from "../PersonalAccessTokens/PersonalAccessTokensContainer";
import PassiveSearchContainer from "../PassiveSearch/PassiveSearchContainer";
import { NotFound } from "../NotFound";
import TourRunner from "../OnboardingTour/TourRunner";
import useAuth from '../../hooks/useAuth';
import { SignInForm } from "../Authentication/SignInForm/SignInForm";
import SubscriptionModal from "./Requirements/SubModal"; 
import UpgradeModal from "./Requirements/upgradeModal";
import VerificationModal from "./Requirements/EmailVerificationModal";
import  VerificationGuard  from "./Requirements/VerificationGuard"; 
import RouteGuard from "./Requirements/RouteGuard";
import SignUpPage from "../Authentication/SignUpForm/SignUpPage"; 
import SignInPage from "../Authentication/SignInForm/SignInPage"; 

export default function App({ user, signOut, isLoading }) {
  const isAuth = !!user;

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <Routes>
      {isAuth ? (
        // AUTHENTICATED ROUTES 
        <Route
          path="/*"
          element={
            <VerificationGuard>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100vh",
                  bgcolor: "grey.200",
                }}
              >
                <TourRunner />
                <Header user={user} signOut={signOut} />
                <Box sx={{ flexGrow: 1, p: 5, bgcolor: "white" }}>
                  {/* Nested routes for the different pages inside your app */}
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <RouteGuard>
                          <IdealCandidatesListingContainer />
                        </RouteGuard>
                      }
                    />
                    <Route
                      path="/ideal-candidates"
                      element={
                        <RouteGuard>
                          <IdealCandidatesListingContainer />
                        </RouteGuard>
                      }
                    />
                    <Route
                      path="/ideal-candidates/:idealCandidateUuid"
                      element={
                        <RouteGuard>
                          <IdealCandidateViewContainer />
                        </RouteGuard>
                      }
                    />
                    <Route
                      path="/pats"
                      element={
                        <RouteGuard>
                          <PersonalAccessTokensContainer />
                        </RouteGuard>
                      }
                    />
                    <Route
                      path="/passive-search"
                      element={
                        <RouteGuard requireTiers={["pro", "enterprise"]}>
                          <PassiveSearchContainer />
                        </RouteGuard>
                      }
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Box>
              </Box>
            </VerificationGuard>
          }
        />
      ) : (
        // PUBLIC ROUTES 
        <>
          <Route path="/signup" element={<SignUpPage />} /> 
          <Route path="/signin" element={<SignInPage />} />
          {/* A catch-all that redirects to signin is good, but make sure it comes after specific routes */}
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </>
      )}
    </Routes>
  );
}